import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import "./tagInputSelect.scss";
import SelectNew from "components/select/SelectNew";
import { Select } from "components/select/index";


export interface IInputProps {
  className?: string;
  label?: any;
  value?: any;
  onChange?: (value: number | string, extraValue?: any) => void;
  onKeyDown?: any;
  multiLine?: any;
  labelHidden?: boolean;
  placeholder?: any;
  helpText?: any;
  tags?: any;
  onTagClick?: (index: number) => void;
  onFocus?: (e: any) => void;
  name?: string;
  id?: any;
  readOnly?: boolean;
  selectOptions?: any;
  onSearch?: (searchQuery: string) => void;
  searchQuery?: string;
}

const TagInputSelect: React.FC<IInputProps> = props => {
  const { className, onChange, onSearch, searchQuery } = props;
  const { Option } = Select;

  return (
    <div className={`tag-input-select ${className ? className : ""}`}>
      {!props.labelHidden ? (
        <div className="tag-input-select_label_container">
          <div className="tag-input-select_label">
            <label style={{ marginBottom: 0 }}>{props.label}</label>
          </div>
        </div>
      ) : null}

      <div className="tag-input-select_container">
        <div
          className="tag-input-select_tags_container"
          style={{ paddingBottom: props.tags.length > 0 ? "10px" : "0px" }}
        >
          {props.tags.map((tag: { name: string; id: number }, index: number) => {
            return (
              <div className="tag-input-select_single_tag_container" key={index}>
                <p className="tag-text">{tag.name}</p>

                <div className="flex items-center" onClick={() => props.onTagClick(tag.id)}>
                  <FontAwesomeIcon fixedWidth icon={faXmark} className="tag-icon" />
                </div>
              </div>
            );
          })}
        </div>

        <div className="tag-input-select_input_container" style={{flex: onSearch && searchQuery !== undefined ? 2 : undefined}}>
          {onSearch && searchQuery !== undefined ? (
             <Select
             showSearch
             onSearch={(query: string) => onSearch(query)}
             onChange={(value: number | string, option) => onChange(value, option)}
             placeholder={t("Search")}
             allowClear
             searchValue={searchQuery}
             showDropDownOnFocus
             searching={!props.selectOptions}
             usePortal
             hideDropdown={false}
           >
             {props.selectOptions?.map((option: any, index: number) => {
               return (
                 <Option key={index} value={option?.id as number} extraValues={option}>
                   {option?.name}
                 </Option>
               );
             })}
           </Select>
          ) : (
            <SelectNew
            id={"tag_select_input"}
            // className="tag-input-select_input_container_select"
            onChange={(value: string | number, option) => onChange(value, option)}
            value={null}
            options={props.selectOptions?.map((option: any) => ({
              id: option.id,
              label: option.name,
              extraValue: option,
            }))}
          />
          )}
        </div>
      </div>

      <div>
        <p className="tag-input-select_help_text">{props.helpText}</p>
      </div>
    </div>
  );
};

export default TagInputSelect;
